<template>
    <v-dialog v-model="dialog" max-width="600px">
        <v-card>
            <v-card-title class="headline">Cancelar Nota Fiscal</v-card-title>
            <v-card-text>
                <p>Você tem certeza que deseja cancelar a nota fiscal?</p>
                <p><strong>Informe o motivo do cancelamento.</strong></p>
            </v-card-text>
            <v-card-text>
                <v-textarea
                    v-model="motivoCancelamento"
                    label="Motivo do Cancelamento (mínimo 15 caracteres)"
                    rows="3"
                    required
                    :error="motivoCancelamento.length > 0 && motivoCancelamento.length < 15"
                    :error-messages="motivoCancelamento.length > 0 && motivoCancelamento.length < 15 ? 'Justificativa deve ter pelo menos 15 caracteres' : ''"
                ></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="confirmarCancelamento" :disabled="motivoCancelamento.length < 15">Confirmar</v-btn>
                <v-btn text @click="$emit('cancel')">
                    Cancelar
                </v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
export default {
    name: 'AlertCancelView',
    props: {
        isOpen: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            dialog: false,
            motivoCancelamento: ''
        };
    },
    watch: {
        isOpen(newVal) {
            this.dialog = newVal;
            this.motivoCancelamento = '';
        }
    },
    methods: {
        confirmarCancelamento() {
            this.$emit('confirmar', this.motivoCancelamento);
        }
    }
};
</script>